// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import request from '../libs/request'


/**
 * @description 墓型展示
 */
export function GraveList (data) {
    return request({
        url: 'pc/get_grave_list',
        method: 'post',
		data:data
    })
}


/**
 * @description 信息分类首页数据,该分类的信息和当前的下级分类
 */
export function InfoGrave(id) {
    return request({
        url: `v1/infograve/${id}`,
        method: 'get',
    })
}


// WEBPACK FOOTER //
// ./src/api/grave.js